import { Footer } from "../../pages/landing/Footer";
import chat from "../../assets/chat.svg";

export function Dashboard({ children }) {
  return (
    <div className=" relative ">
      {children}
      <button className="bg-[#fcb108]/80 flex justify-center items-center w-[86px] h-[86px] rounded-full top-[80%] right-[5%] fixed z-50">
        <img src={chat} alt="" />
      </button>
      <Footer />
    </div>
  );
}
